import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../../shared/pipes/shared-pipes.module';
import { CustomerImageModule } from '../../image/customer-image.module';
import { CustomerPipeModule } from '../../shared/pipes/customer-pipe.module';
import { CustomerSearchResultsComponent } from './search-results.component';

@NgModule({
    declarations: [
        CustomerSearchResultsComponent
    ],
    imports: [
        CommonModule,
        CustomerImageModule,
        CustomerPipeModule,
        RouterModule,
        SharedPipesModule,
        TableModule
    ],
    exports: [
        CustomerSearchResultsComponent
    ]
})

export class CustomerSearchResultsModule {
}
